import React from "react";
import { FormattedMessage } from "react-intl";
import CheckboxInput from "shared/forms/inputs/CheckboxInput";

export const FIELD_CONSENT = "consent";

export interface AgeConsentCheckboxProps {
  consentAge: number;
}

export const AgeConsentCheckbox = ({ consentAge }: AgeConsentCheckboxProps) => {
  return (
    <CheckboxInput
      inputID={FIELD_CONSENT}
      label={
        <FormattedMessage
          id="landing.subscription.field.consent_age"
          values={{ consentAge }}
        />
      }
    />
  );
};
